<template>
  <Modal
    v-model:show="active"
    class="offer get-links-modal"
    @close="close"
  >
    <template v-slot:header>
      <h5 class="modal-title mt-8">
        {{ $t('androidApp.downloadApp') }}
      </h5>
    </template>
    <div class="mt-12">
      <AndroidAppsForm
        v-if="active"
        :media-buying-campaign-id="mediaBuyingCampaignId"
        :is-sub-affiliate="$store.state.profile.user.referral_program_enabled"
      />
    </div>
    <template v-slot:footer>
      <button
        class="btn btn-outline-primary btn-sm btn-close-modal"
        @click="close"
      >
        {{ $t('offer.offerRequestSuccess.close') }}
      </button>
    </template>
  </Modal>
</template>

<script>
import { Modal } from 'src/components';
import AndroidAppsForm from '@/components/AndroidApps.vue';

export default {
  components: {
    AndroidAppsForm,
    Modal,
  },
  props: {
    mediaBuyingCampaignId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      active: false,
      loading: false,
    };
  },
  methods: {
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
    },
  },
};
</script>
